import { Member } from './use-api-client';

export const getInitials = (member: Member) =>
  `${member.firstName.slice(0, 1)}${member.lastName.slice(0, 1)}`;
